export const environment = {
    production: false,
    identityUrl: 'https://identity-v2-staging.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://forms-v3-staging.nside.io',
    apiBaseUrl: 'https://v3-api-staging.nside.io',
};
  